import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7a4fad6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "app-mobile-navigation",
  ref: "navigationRefElement"
}
const _hoisted_2 = { key: "goals" }
const _hoisted_3 = { key: "pulse" }
const _hoisted_4 = {
  class: "sync",
  key: "sync"
}
const _hoisted_5 = { key: "insights" }
const _hoisted_6 = {
  class: "dre",
  key: "dre"
}
const _hoisted_7 = {
  key: 0,
  class: "counter"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "32",
  height: "18",
  viewBox: "0 0 32 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M27.2705 11.5763C27.285 12.9113 26.9944 13.7226 26.6166 14.2506C26.2375 14.7804 25.64 15.2071 24.7043 15.5299C22.7075 16.2186 19.8133 16.2458 16.124 16.2502C12.4346 16.2546 9.53989 16.2344 7.5281 15.5504C6.58527 15.2299 5.97854 14.8046 5.58787 14.2757C5.1986 13.7487 4.8904 12.9381 4.8759 11.6031C4.81878 6.34472 9.59481 1.75753 15.9665 1.74991C22.338 1.74229 27.2134 6.31818 27.2705 11.5763ZM28.9694 12.6701C28.3818 17.9781 22.8597 17.9921 16.143 18.0001C9.59997 18.0079 4.19011 18.0074 3.26493 13.102C0.935483 11.31 -0.436592 9.26884 0.125807 8.29474C0.54264 7.57276 1.91818 7.617 3.62996 8.28069C5.17399 3.49723 10.0871 0.00701754 15.9475 1.05666e-05C21.6558 -0.00681462 26.537 3.29344 28.3093 7.88181C29.7114 7.0277 30.9379 6.73034 31.4911 7.22163C32.3624 7.99551 31.2336 10.4336 28.9694 12.6701ZM12.6997 10.2306C11.4892 10.0865 10.3639 10.2877 9.59243 10.7186C9.47301 10.4064 9.38988 10.068 9.35102 9.71147C9.15712 7.93213 10.1397 6.37662 11.5457 6.23715C12.9516 6.09767 14.2486 7.42703 14.4425 9.20637C14.4981 9.71648 14.457 10.2082 14.337 10.6534C13.853 10.4498 13.2981 10.3018 12.6997 10.2306ZM20.9468 10.3799C19.6631 10.011 18.4139 10.0677 17.572 10.4568C17.4953 10.1128 17.4631 9.74576 17.4832 9.36669C17.5775 7.57931 18.7972 6.2018 20.2073 6.28994C21.6174 6.37807 22.6841 7.89848 22.5897 9.68587C22.5657 10.1403 22.469 10.5682 22.3149 10.9523C21.9108 10.7207 21.4496 10.5244 20.9468 10.3799Z",
    fill: "currentColor"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppDismissibleBanner = _resolveComponent("AppDismissibleBanner")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ListTransition = _resolveComponent("ListTransition")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_ctx.updateExists)
      ? (_openBlock(), _createBlock(_component_AppDismissibleBanner, {
          key: 0,
          message: "A new version of Cadrelo is available",
          subtitle: "View release notes",
          "button-text": "Update",
          "onUserAction:update": _ctx.handleRefreshApp,
          "onUserAction:dismiss": _ctx.dismissUpdateNotification
        }, null, 8, ["onUserAction:update", "onUserAction:dismiss"]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", null, [
      _createVNode(_component_ListTransition, null, {
        default: _withCtx(() => [
          _createElementVNode("li", _hoisted_2, [
            _createVNode(_component_router_link, { to: "/goals" }, {
              default: _withCtx(() => [
                _createVNode(_component_AppIcon, {
                  name: "flag",
                  size: "20"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_3, [
            _createVNode(_component_router_link, { to: { path: `/pulse` } }, {
              default: _withCtx(() => [
                _createVNode(_component_AppIcon, {
                  name: "pulse",
                  size: "20"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_4, [
            _createVNode(_component_router_link, { to: { path: `/` } }, {
              default: _withCtx(() => [
                _createVNode(_component_AppIcon, {
                  name: "plays",
                  size: "28"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/team" }, {
              default: _withCtx(() => [
                _createVNode(_component_AppIcon, {
                  name: "insights",
                  size: "22"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("a", {
              class: "item",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDreTray()))
            }, [
              (_ctx.unread)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.unread), 1))
                : _createCommentVNode("", true),
              _hoisted_8
            ])
          ])
        ]),
        _: 1
      })
    ])
  ], 512))
}